import { render, staticRenderFns } from "./CustomerProductMix.vue?vue&type=template&id=26bf8408&scoped=true&"
import script from "./CustomerProductMix.vue?vue&type=script&lang=ts&"
export * from "./CustomerProductMix.vue?vue&type=script&lang=ts&"
import style0 from "./CustomerProductMix.vue?vue&type=style&index=0&id=26bf8408&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26bf8408",
  null
  
)

export default component.exports